/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { MdClose } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import {
  Container,
  SendProject,
  Header,
  SubHeader,
  Body,
  Modal,
} from './styles';
import Projetos from '../../assets/images/projetos.png';
import All from '../../assets/images/all.png';
import api from '../../services/api';

export default function Project() {
  const { id } = useParams();
  const user = useSelector((state) => state.user.profile);
  const [project, setProject] = useState('');
  const [modal, setModal] = useState(false);
  const [answer, setAnswer] = useState('');
  const [challengesSentModule, setChallengesSentModule] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);

  useEffect(() => {
    async function getDataChallenges() {
      const { data } = await api.get(`/modules/${id}/challenges`);
      setProject(data[0]);
    }

    async function getIdsModule() {
      const { data } = await api.get(`/allchallenges/${id}`);
      setChallengesSentModule(data);
    }

    getDataChallenges();
    getIdsModule();
  }, [id]);

  function handleModal() {
    modal ? setModal(false) : setModal(true);
  }

  const handleInputChange = (e) => {
    const { value } = e.target;
    setAnswer(value);
  };

  async function handleSubmit(e) {
    e.preventDefault();
    if (answer.includes('github')) {
      try {
        if (answer) {
          await api.post(`challenges/${project.id}/scorecards/`, {
            user_id: user.id,
            link_answer: answer,
            code_answer: '.',
            module_id: project.module_id,
          });
          toast.success('Desafio enviado com sucesso!');
          setButtonDisable(true);
          return handleModal();
        }
        setButtonDisable(true);
        return toast.error('Preencha o campo de resposta e tente novamente.');
      } catch (error) {
        return toast.warn('Desafio já enviado, veja sua página de desafios.');
      }
    } else {
      return toast.error('Ops, envie um repositório do Github.');
    }
  }

  return (
    <Container>
      {modal ? (
        <Modal>
          <div>
            <MdClose
              color="#fff"
              size={60}
              style={{ marginLeft: '30vw', cursor: 'pointer' }}
              onClick={handleModal}
            />
            <h1>Enviar Projeto</h1>
            <div>
              <input
                type="text"
                name="project"
                id="project"
                placeholder="Link do Github"
                value={answer}
                onChange={(value) => handleInputChange(value)}
              />
              <button type="button" onClick={(e) => handleSubmit(e)}>
                OK
              </button>
            </div>
          </div>
        </Modal>
      ) : null}
      <Header>
        <p
          style={{
            fontSize: 26,
            paddingLeft: 30,
            color: '#36DED6',
            fontWeight: 'bold',
            paddingTop: 30,
          }}
        >
          Módulo: Projeto {project.title}
        </p>
      </Header>

      <SubHeader>
        <img
          src={Projetos}
          alt="projetos"
          style={{
            width: '80%',
            borderRadius: 10,
            marginLeft: '10%',
            marginTop: 50,
            marginBottom: 30,
          }}
        />
      </SubHeader>
      <Body>
        <p className="label">Objetivo:</p>
        <p> {project.question}</p>
        <p className="label">Descriçāo:</p>
        <p>{project.description}</p>
        <p className="label">Repositório do Desafio:</p>
        <a
          href={project.link_question}
          target="_blank"
          rel="noopener noreferrer"
        >
          <button type="button">VER REPOSITÓRIO</button>
        </a>
      </Body>
      <SendProject>
        <div>
          <img src={All} alt="icon" />
          <p>Projeto - {project.title}</p>
        </div>
        <div>
          <button
            type="button"
            onClick={handleModal}
            disabled={challengesSentModule.length === 1 || buttonDisable}
          >
            {challengesSentModule.length === 1 || buttonDisable
              ? 'DESAFIO ENVIADO'
              : 'ENVIAR DESAFIO'}
          </button>
        </div>
      </SendProject>
    </Container>
  );
}
